import React, { Suspense } from 'react'; // component to prevent rendering until the request is complete
import { render } from 'react-dom';
import './i18n';

import { ThemeProvider } from './contexts/theme';
import App from './App';

render(
  <Suspense fallback=''>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Suspense>,
  document.getElementById('root')
);
